import type * as LocationCourseCards from '../types/LocationCourseCards'

export default function locationCourseCardsComponentParser(
  rawComponent: LocationCourseCards.Raw,
): LocationCourseCards.Parsed {
  const props = rawComponent.locationCourseCards

  return {
    name: 'LocationCourseCards',
    props,
  }
}
